import History from "./HistoryContainer";

export default History;
